<template>
    <jet-form-section>
        <template #title>{{ $t("profile.timezone.title") }}</template>

        <template #description>{{
            $t("profile.timezone.description")
        }}</template>

        <template #form>
            <div class="gap-1 sm:col-span-4 col-span-6 grid">
                <Label for="timezone">
                    {{ $t("profile.timezone.title") }}</Label
                >

                <Select v-model="form.timezone">
                    <SelectTrigger>
                        <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                        <SelectGroup>
                            <SelectItem
                                v-for="tz in timezones"
                                :key="tz"
                                :value="tz"
                            >
                                {{ tz }}
                            </SelectItem>
                        </SelectGroup>
                    </SelectContent>
                </Select>
            </div>
        </template>

        <template #actions>
            <Button
                :loading="form.processing"
                :recently-successful="form.recentlySuccessful"
                @click.prevent="updateTimezone"
                size="sm"
                >{{ $t("save_changes") }}</Button
            >
        </template>
    </jet-form-section>
</template>

<script setup lang="ts">
import JetFormSection from "../../Jetstream/FormSection.vue";
import { Label } from "@/components/ui/label";
import { onMounted, ref } from "vue";
import route from "ziggy-js";
import { useForm } from "@inertiajs/vue3";
import axios from "axios";
import { User } from "../Zaptime/App/Teams/types/Team";
import { Button } from "@/components/ui/button";
import {
    Select,
    SelectContent,
    SelectGroup,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@/components/ui/select";

interface Props {
    user: User;
}

const props = defineProps<Props>();

const timezones = ref<string[]>([]);

const form = useForm({
    timezone: props.user.timezone,
});

const updateTimezone = function () {
    form.put(route("user.update-timezone"));
};

onMounted(async () => {
    const response = await axios.get(route("api.timezones.index"));
    timezones.value = response.data.data;
});
</script>
